module.exports = __webpack_public_path__ + "static/media/arrow-icon.41ceed7f.svg";